import {BaseContainerModel} from '../../base-container.model';
import {bl_inv_mst_location_RowClass} from '../../../dbschema';

export class LocationHeaderContainerModel extends BaseContainerModel {
  bl_inv_mst_location: bl_inv_mst_location_RowClass = new bl_inv_mst_location_RowClass();
}
